import { render, staticRenderFns } from "./TableStats.vue?vue&type=template&id=74f70fd6"
import script from "./TableStats.js?vue&type=script&lang=js&external"
export * from "./TableStats.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports